import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CareLink, InviteCaregiverRequest } from '@app/core/api/care-links';

export const CareLinksActions = createActionGroup({
  source: 'Care Links',
  events: {
    'Load Caregivers': emptyProps(),
    'Load Caregivers Success': props<{ caregivers: CareLink[] }>(),
    'Load Caregivers Failure': props<{ error: string }>(),

    'Invite Caregiver': props<{ request: InviteCaregiverRequest }>(),
    'Invite Caregiver Success': props<{ careLink: CareLink }>(),
    'Invite Caregiver Failure': props<{ error: string; status?: number }>(),

    'Revoke Link': props<{ linkId: string }>(),
    'Revoke Link Success': props<{ linkId: string }>(),
    'Revoke Link Failure': props<{ error: string }>(),

    'Resend Invitation': props<{ linkId: string }>(),
    'Resend Invitation Success': props<{ careLink: CareLink }>(),
    'Resend Invitation Failure': props<{ error: string }>(),

    'Clear Care Links State': emptyProps(),
    'Clear Error': emptyProps(),
  }
});
